import { formatCountdown } from "@teamna/web-client/lib/format.ts";

/**
 * Small text helpers the admin pages share.
 *
 * The sport is the system name from the API ("swimming"). The admin area is Teamna's own view, not
 * a business's, so it shows the system name with a capital letter and no per-business label.
 */
export function sportName(sport: string): string {
  if (!sport) return "";
  return sport.charAt(0).toUpperCase() + sport.slice(1);
}

/** "3 days ago", or "never" when the business has no audit row yet. */
export function lastActivityText(iso: string | null): string {
  return iso === null ? "never" : formatCountdown(iso);
}

/** "6 of 8" */
export function setupText(done: number, total: number): string {
  return `${done} of ${total}`;
}

/** "1 business", "3 businesses" */
export function countText(count: number, singular: string, plural: string): string {
  return `${count} ${count === 1 ? singular : plural}`;
}
